import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { IconModule } from '@visurel/iconify-angular';
import { MatDatepickerModule, MatDialogModule } from '@angular/material';
import { ErrorDialogComponent } from './error-message-dialog.component'
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { createTranslateLoader } from 'src/app/translate.common';
import { HttpClient } from '@angular/common/http';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    IconModule,
    MatDatepickerModule,
    MatDialogModule,
    TranslateModule.forChild({
      //language code
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
      isolate: true,
    }),
  ],
  declarations: [ErrorDialogComponent],
  exports: [ErrorDialogComponent],
  entryComponents : [ErrorDialogComponent]
})
export class ErrorDialogModule {
}
